import React from "react";

const SearchResultBuilding = ({ item, close }) => {
	return <></>;
};

export default SearchResultBuilding;
